import { countryFromHost } from './country'

export const environmentFromHost = (host = window.location.host) =>
    countryFromHost(host.toLowerCase().replace('acc-', ''))

export const isQAEnviroment = (host = window.location.host) => {
    const qaMatch = host.toLowerCase().match(/testindigo|localhost/)
    return Boolean(qaMatch)
}
